import { Theme, ThemeType } from "components/Shared";
import { URQLProvider } from "components/URQLProvider";
import { ConnectedRouter } from "connected-react-router";
import { History } from "history";

import { StudioConfig } from "models/Config";
import { WidgetSamplePageContainer } from "pages/WidgetSamplePage";
import React, { FC, useCallback } from "react";
import { ThemeProvider } from "react-css-themr";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { Store } from "redux";
import { State } from "redux/state";
import Routes from "routes";
import theme from "styles/react-toolbox-themes";
import { useLocalStorageString } from "utils/localStorage";
import { PageTrackingWrapper } from "utils/usePageTracking";

interface RootContainerProps {
    config: StudioConfig;
    store: Store<State>;
    history: History;
}

export const RootContainer: FC<RootContainerProps> = (props: RootContainerProps) => {
    const { config, store, history } = props;

    const api = config.apiUrl;

    const comp = useCallback(
        () => (
            <URQLProvider api={api}>
                <Routes history={history} store={store} config={config} />
            </URQLProvider>
        ),
        [api, config, store, history]
    );

    const [appearance] = useLocalStorageString<ThemeType>("theme");

    return (
        <ThemeProvider theme={theme}>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <PageTrackingWrapper />
                    <Theme theme={appearance}>
                        <link rel="stylesheet" href="https://use.typekit.net/irx2kpk.css" />
                        <Switch>
                            <Route path="/widget" component={WidgetSamplePageContainer} />
                            <Route path="/" component={comp} />
                        </Switch>
                    </Theme>
                </ConnectedRouter>
            </Provider>
        </ThemeProvider>
    );
};
